import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SALES_STATISTICS_STATISTIC_TYPES } from '../sales-statistics.api';
import { StatisticType } from '../types/statistic-type';

@Injectable()
export class StatisticTypesRepository extends ReadonlyHttpApiCollectionRepository<
  StatisticType[]
> {
  constructor() {
    super(inject(ApiDataAccess), SALES_STATISTICS_STATISTIC_TYPES);
  }
}
